import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { initLanding, LandingApplication } from './biyaheko-landing.script';

/** Session key the signup page reads to prefill itself (e.g. the tier picked on the landing page). */
export const SIGNUP_PREFILL_KEY = 'bk_signup_prefill';

/**
 * Biyaheko landing page (the home page). Markup and styles are ported from the
 * BIYAHEKO landing export; behaviour lives in biyaheko-landing.script.ts.
 * ViewEncapsulation.None because the script builds markup at runtime; every rule
 * in the stylesheet is scoped under .bk-landing so nothing leaks into the app.
 */
@Component({
  selector: 'bta-biyaheko-landing',
  standalone: true,
  templateUrl: './biyaheko-landing.component.html',
  styleUrls: ['./biyaheko-landing.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class BiyahekoLandingComponent implements AfterViewInit, OnDestroy {
  @ViewChild('root', { static: true }) root: ElementRef<HTMLElement>;
  private teardown?: () => void;

  constructor(private zone: NgZone, private router: Router, private route: ActivatedRoute) { }

  ngAfterViewInit() {
    // Animation loops and timers run outside Angular so they don't trigger change detection.
    this.zone.runOutsideAngular(() => {
      this.teardown = initLanding(this.root.nativeElement, {
        navigate: (url) => this.zone.run(() => this.router.navigateByUrl(url)),
        apply: (details) => this.zone.run(() => this.continueToSignup(details)),
      });
    });
    // Arriving with a fragment (e.g. /home-page#faq): scroll to that section.
    const fragment = this.route.snapshot.fragment;
    if (fragment) {
      setTimeout(() => this.root.nativeElement.querySelector('#' + CSS.escape(fragment))
        ?.scrollIntoView({ block: 'start' }), 300);
    }
  }

  /** Hand what the visitor picked to the register page, which prefills from it. */
  private continueToSignup(details: Partial<LandingApplication>) {
    try {
      sessionStorage.setItem(SIGNUP_PREFILL_KEY, JSON.stringify(details));
    } catch (e) { }
    this.router.navigateByUrl('/signup');
  }

  ngOnDestroy() {
    this.teardown?.();
  }
}
